"use client";

import { c as _c } from "react/compiler-runtime";
import { Collapse } from "@/components/Collapse/Collapse.component";
import { CommentForm } from "@/components/Comment/components/form/CommentForm.component";
import { CommentItem } from "@/components/Comment/components/thread/CommentItem.component";
import { CommentReplies } from "@/components/Comment/components/thread/CommentReplies.component";
import { CommentProvider } from "@/components/Comment/context/comment.context";
import { useCommentThread } from "@/components/Comment/hooks/use-comment-thread.hook";
import type { CommentModel } from "@/services/api/comment/models/comment.model.types";
type CommentThreadProps = {
  readonly comment: CommentModel;
  readonly depth?: number;
};
export function CommentThread(t0) {
  const $ = _c(26);
  const {
    comment,
    depth: t1
  } = t0;
  const depth = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== comment || $[1] !== depth) {
    t2 = {
      comment,
      depth
    };
    $[0] = comment;
    $[1] = depth;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const thread = useCommentThread(t2);
  let t3;
  if ($[3] !== comment || $[4] !== depth || $[5] !== thread) {
    t3 = {
      comment,
      depth,
      thread
    };
    $[3] = comment;
    $[4] = depth;
    $[5] = thread;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CommentItem />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== comment.id || $[9] !== comment.revisionId) {
    t5 = {
      id: comment.id,
      revisionId: comment.revisionId
    };
    $[8] = comment.id;
    $[9] = comment.revisionId;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5 || $[12] !== thread.ancestorId || $[13] !== thread.closeReplyForm) {
    t6 = <div className="mt-5"><CommentForm ancestorId={thread.ancestorId} onCancel={thread.closeReplyForm} onSuccess={thread.closeReplyForm} parent={t5} /></div>;
    $[11] = t5;
    $[12] = thread.ancestorId;
    $[13] = thread.closeReplyForm;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6 || $[16] !== thread.isReplying) {
    t7 = <Collapse duration={200} isExpanded={thread.isReplying}>{t6}</Collapse>;
    $[15] = t6;
    $[16] = thread.isReplying;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== thread.showReplies) {
    t8 = thread.showReplies ? <CommentReplies /> : null;
    $[18] = thread.showReplies;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <div className="mt-5">{t4}{t7}{t8}</div>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t3 || $[24] !== t9) {
    t10 = <CommentProvider value={t3}>{t9}</CommentProvider>;
    $[23] = t3;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}